import { withInstall } from '@xzx-design/utils'
import _Grid from './src/grid'
import _GridItem from './src/grid-item'

export const Grid = withInstall(_Grid)
export const GridItem = withInstall(_GridItem)
export default Grid

export * from './src/grid'
export * from './src/grid-item'
export * from './src/types'
